import type {
  ProtectionFilters,
  ProtectionResponseApi,
  ProtectionResponse,
  ProtectionReviewPayload,
  TwilioComparisonResponseApi,
  TwilioComparisonResponse,
} from '@/types/Api/SmsProtection'
import type { AxiosItem } from '@/types/Components/Response'
import { protectionTimezone } from '@/const/MessagingProtection'
import { BaseProxy } from '@/proxies/Proxy'
import SmsProtectionTransformer from '@/transformers/SmsProtectionTransformer'

export default class SmsProtectionProxy extends BaseProxy {
  public endpoint = 'sms-protection'

  async observations(filters: ProtectionFilters): Promise<ProtectionResponse> {
    this.parameters = {
      timezone: protectionTimezone,
      page: filters.page,
      from: filters.from,
      to: filters.to,
      decision: filters.decision,
      shipment_number: filters.shipmentNumber,
    }
    const { data } = await this.submit<AxiosItem<ProtectionResponseApi>>('get', `/${this.endpoint}`)
    return SmsProtectionTransformer.fetch(data)
  }

  async twilio(from: string, to: string, page: number): Promise<TwilioComparisonResponse> {
    this.parameters = { from, to, twilio_page: page, timezone: protectionTimezone }
    const { data } = await this.submit<AxiosItem<TwilioComparisonResponseApi>>('get', `/${this.endpoint}/twilio`)
    return SmsProtectionTransformer.twilio(data)
  }

  async review(id: number, payload: ProtectionReviewPayload): Promise<{ id: number }> {
    const { data } = await this.submit<AxiosItem<{ id: number }>>('post', `/${this.endpoint}/${id}/reviews`, payload)
    return data
  }
}
